/* global jacketDataCm, jacketDataInch, pantDataCm, pantDataInch, shirtDataCm, shirtDataInch */
document.addEventListener("DOMContentLoaded", function () {
  let currentLength = "short"; // short, regular, long
  let jacketUnit = "cm"; // cm, inch
  let pantUnit = "cm"; // cm, inch
  let shirtUnit = "cm"; // cm, inch
  let productType = ""; // shirt, jacket, pant, suit, stretch, tuxedo

  const offcanvas = document.getElementById("size-guide-offcanvas");
  const overlay = document.getElementById("size-guide-overlay");
  const openButtons = document.querySelectorAll("#open-size-guide");
  const closeButtons = document.querySelectorAll("#close-size-guide, #size-guide-overlay");

  if (!offcanvas) return; // Exit if not on a product page with size guide

  // Function to determine product type from the drawer's data attribute
  function detectProductType() {
    const typeStr = offcanvas.getAttribute("data-product-type");
    if (!typeStr) return;
    
    const type = typeStr.toLowerCase();
    
    if (type.includes("shirt") || type.includes("stretch")) {
      productType = "shirt";
      currentLength = "cm"; // Not used for shirts, but set for safety
    } else if (type.includes("suit") || type.includes("tuxedo")) {
      productType = "suit"; // Shows both jacket and pant
      currentLength = "short";
    } else if (type.includes("pant")) {
      productType = "pant";
      currentLength = "short";
    } else {
      // Default to jacket for 'Sports Jacket' or unknown
      productType = "jacket";
      currentLength = "short";
    }
  }

  // Open offcanvas
  openButtons.forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (offcanvas) offcanvas.classList.remove("translate-x-full");
      if (overlay) overlay.classList.remove("hidden");
      document.body.classList.add("overflow-hidden");
      
      detectProductType();
      updateTables();
    });
  });

  // Close offcanvas
  closeButtons.forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (offcanvas) offcanvas.classList.add("translate-x-full");
      if (overlay) overlay.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
    });
  });

  // Event Delegation for dynamically rendered buttons
  document.addEventListener("click", function(e) {
    // Length toggles (Short, Regular, Long)
    if (e.target.closest(".length-toggle")) {
      e.preventDefault();
      const btn = e.target.closest(".length-toggle");
      document.querySelectorAll(".length-toggle").forEach(el => {
        el.classList.remove("active");
      });
      btn.classList.add("active");
      currentLength = btn.getAttribute("data-length");
      updateTables();
    }

    // Shirt unit toggles
    if (e.target.closest(".shirt-unit-toggle")) {
      e.preventDefault();
      const btn = e.target.closest(".shirt-unit-toggle");
      document.querySelectorAll(".shirt-unit-toggle").forEach(el => {
        el.classList.remove("active");
      });
      btn.classList.add("active");
      shirtUnit = btn.getAttribute("data-unit");
      updateTables();
    }

    // Jacket unit toggles
    if (e.target.closest("#jacket-unit-cm") || e.target.closest("#jacket-unit-inch")) {
      e.preventDefault();
      const btn = e.target.closest(".unit-switch");
      document.querySelectorAll("#jacket-unit-cm, #jacket-unit-inch").forEach(el => {
        el.classList.remove("active");
      });
      btn.classList.add("active");
      jacketUnit = btn.getAttribute("id") === "jacket-unit-cm" ? "cm" : "inch";
      updateTables();
    }

    // Pant unit toggles
    if (e.target.closest("#pant-unit-cm") || e.target.closest("#pant-unit-inch")) {
      e.preventDefault();
      const btn = e.target.closest(".unit-switch");
      document.querySelectorAll("#pant-unit-cm, #pant-unit-inch").forEach(el => {
        el.classList.remove("active");
      });
      btn.classList.add("active");
      pantUnit = btn.getAttribute("id") === "pant-unit-cm" ? "cm" : "inch";
      updateTables();
    }
  });

  function updateTables() {
    const jacketTable = document.getElementById("jacket-size-guide-table");
    const pantTable = document.getElementById("pant-size-guide-table");
    const shirtTable = document.getElementById("shirt-size-guide-table");
    const lengthContainer = document.querySelector(".length-toggle-container");
    const jacketSection = document.getElementById("jacket-section");
    const pantSection = document.getElementById("pant-section");
    const shirtSection = document.getElementById("shirt-section");

    // Hide everything first
    if (lengthContainer) lengthContainer.style.display = "none";
    if (jacketSection) jacketSection.style.display = "none";
    if (pantSection) pantSection.style.display = "none";
    if (shirtSection) shirtSection.style.display = "none";

    // Show depending on product type
    if (productType === "shirt") {
      if (shirtSection) shirtSection.style.display = "block";
      if (shirtTable) shirtTable.innerHTML = generateShirtContent(shirtUnit);
    } 
    else if (productType === "suit") {
      if (lengthContainer) lengthContainer.style.display = "flex";
      if (jacketSection) jacketSection.style.display = "block";
      if (pantSection) pantSection.style.display = "block";
      if (jacketTable) jacketTable.innerHTML = generateJacketTable(currentLength, jacketUnit);
      if (pantTable) pantTable.innerHTML = generatePantTable(currentLength, pantUnit);
    } 
    else if (productType === "pant") {
      if (lengthContainer) lengthContainer.style.display = "flex";
      if (pantSection) pantSection.style.display = "block";
      if (pantTable) pantTable.innerHTML = generatePantTable(currentLength, pantUnit);
    } 
    else { // Jacket or stretch
      if (lengthContainer) lengthContainer.style.display = "flex";
      if (jacketSection) jacketSection.style.display = "block";
      if (jacketTable) jacketTable.innerHTML = generateJacketTable(currentLength, jacketUnit);
    }
  }

  function generateJacketTable(length, unit) {
    const allData = unit === "cm" ? jacketDataCm : jacketDataInch;
    const filtered = allData.filter(row => sizeMatchesLength(row.size, length));
    return buildTable(filtered);
  }

  function generatePantTable(length, unit) {
    const allData = unit === "cm" ? pantDataCm : pantDataInch;
    const filtered = allData.filter(row => sizeMatchesLength(row.size, length));
    return buildTable(filtered);
  }

  function generateShirtContent(unit) {
    const allData = unit === "cm" ? shirtDataCm : shirtDataInch;
    
    // Create the unit toggle buttons for shirts - aligned to right
    const unitButtons = `
      <div class="size-guide-shirt-units">
        <div class="flex-end">
          <button class="shirt-unit-toggle unit-switch ${unit === 'cm' ? 'active' : ''}" data-unit="cm">In cm</button>
          <button class="shirt-unit-toggle unit-switch ${unit === 'inch' ? 'active' : ''}" data-unit="inch">In inches</button>
        </div>
      </div>
    `;

    return unitButtons + buildTable(allData);
  }

  function sizeMatchesLength(size, length) {
    if (length === "short") return size.endsWith("S");
    if (length === "regular") return size.endsWith("R");
    if (length === "long") return size.endsWith("L");
    return false;
  }

  function buildTable(data) {
    if (!data || !data.length) return "<p>No data available.</p>";
  
    const attributes = Object.keys(data[0]).filter(key => key !== "size");
  
    let html = `
      <div class="size-guide-table-wrapper">
      <table class="size-guide-table">
        <thead>
          <tr>
            <th>Attribute</th>
            ${data.map(item => `<th>${item.size}</th>`).join("")}
          </tr>
        </thead>
        <tbody>
    `;
  
    attributes.forEach(attr => {
      html += `<tr><td>${attr}</td>`;
      data.forEach(item => {
        html += `<td>${round2(item[attr])}</td>`;
      });
      html += `</tr>`;
    });
  
    html += `</tbody></table></div>`;
    return html;
  }

  function round2(value) {
    if (typeof value === 'string' && value.includes('-')) {
      return value;
    }
  
    if (!isNaN(value) && value !== null && value !== undefined) {
      return Math.round(Number(value) * 100) / 100;
    }
    
    return value;
  }
});
